<template>
  <div>
    <section class="container topo-intermediaria">
      <div class="row">
        <div class="col-12 col-md-4">
          <img :src="imagem" :alt="descricaoImagem" class="img-fluid mt-3 disciplina-int" v-if="imagem" />
        </div>
        <div class="col-12 col-md-8">
          <p>SISTEMA</p>
          <h1>{{ nome }}</h1>
          <p v-html="descricao"></p>
        </div>
      </div>
    </section>
    <section class="destaques-logado">
      <div class="container">
        <div class="row align-items-center">
          <div class="col">
            <div class="d-flex align-items-center mt-md-4 ml-md-5">
              <i class="fas fa-video"></i>
              <div>
                <p><animated-number :value="estatisticas.totalVideos" :formatValue="formatIntegerNumber" :duration="800"/></p>
                <p>Videos</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex align-items-center mt-md-4 ml-md-5">
              <i class="fas fa-clock"></i>
              <div>
                <p>{{ tempoTotalCursoFormatado }}</p>
                <p>Tempo total de curso</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex align-items-center mt-md-4 ml-md-5">
              <i class="fas fa-book-open"></i>
              <div>
                <p><animated-number :value="estatisticas.anexos" :formatValue="formatIntegerNumber" :duration="800"/></p>
                <p>Resumos</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="conteudo-intermediaria">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2>Cursos dessa disciplina</h2>
            <div class="row cursos-int">
              <div class="col-6 col-md-2" v-for="curso in cursos">
                <a @click="$router.push(curso.url)" href="javascript:void(0)"><img :src="curso.imagem" :alt="`Capa do curso ${curso.referencia}`" class="img-fluid"></a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import SistemaAPI from '@/api/sistema-api'
import ImageUtils from '@/core/utils/image-utils'
import AnimatedNumber from 'animated-number-vue'

export default {
  name: 'SistemaView',
  components: { AnimatedNumber },
  data () {
    return {
      nome: '',
      descricao: '',
      imagem: '',
      cursos: [],
      estatisticas: {
        totalVideos: 0,
        tempoCurso: { horas: 0, minutos: 0 },
        anexos: 0
      }
    }
  },

  mounted () {
    const referencia = this.$route.params.referencia

    SistemaAPI.obterPorReferencia(referencia).then(data => {
      if (data.sistemas) {
        this.nome = data.sistemas.sistema
        this.descricao = data.sistemas.descricao
        this.imagem = ImageUtils.obterUrlCompletaImagem(`${data.sistemas.imagem}`, 'sistemas-app/')
        this.cursos = data.cursos.map(curso => {
          curso.url = `/cursos/detalhe/${curso.referencia}`
          curso.imagem = ImageUtils.obterUrlCompletaImagem(`${curso.imagem}`, 'cursos-plataforma/')
          return curso
        })
      }
    })

    SistemaAPI.obterEstatisticas(referencia).then(data => {
      if (data) {
        this.estatisticas = {
          totalVideos: data.videos_curso,
          tempoCurso: { horas: data.horas_curso ? data.horas_curso : 0, minutos: data.minutos_curso ? data.minutos_curso : 0 },
          anexos: data.anexos_curso ? data.anexos_curso.totalResumos : 0
        }
      }
    })
  },

  computed: {
    descricaoImagem: function () {
      return 'Imagem ' + this.nome
    },

    tempoTotalCursoFormatado: function () {
      return `${this.estatisticas.tempoCurso.horas}H${this.estatisticas.tempoCurso.minutos}`
    }
  },

  methods: {
    formatIntegerNumber (value) {
      return Number(value).toFixed(0)
    }
  }
}
</script>

<style scoped>

</style>
